var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlayIconWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.939,
    height: 15.527,
    fill: "white",
    viewBox: "0 0 12.939 15.527",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "_211876_play_icon",
    "data-name": "211876_play_icon",
    d: "M108.5,70.829l-11.257-6.7A.849.849,0,0,0,96.8,64a.807.807,0,0,0-.8.809h0V78.718h0a.807.807,0,0,0,.8.809.925.925,0,0,0,.453-.137L108.5,72.7a1.217,1.217,0,0,0,0-1.868Z",
    transform: "translate(-96 -64)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayIconWhite);
export default __webpack_public_path__ + "static/media/play_icon_white.e77a8beece15d5a3f429c7e3b7c88c7b.svg";
export { ForwardRef as ReactComponent };